module.exports = __webpack_public_path__ + "static/media/YB5F07_5.938c96fa.jpg";